var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTube = function SvgTube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 39,
    fill: "none",
    viewBox: "0 0 40 39"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#003075",
    strokeWidth: 2,
    d: "M12.5 10.084h15v24.415a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#003075",
    strokeWidth: 2,
    d: "M27.5 10.5h-15v-7a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1zM25.5 16h2v13h-2a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3ZM16.5 3.5v6M23.5 3.5v6M20 3.5v6"
  })));
};
export default SvgTube;